export enum TicketStatus {
  AVAILABLE = 'available',
  SOLD = 'sold',
  CANCELLED = 'cancelled',
  ON_HOLD = 'on_hold',
  USED = 'used',
}
